import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ImageCard from '../image/CardImage/ImageCard';
import Icon from '../Icon/Icon';

const CardsComponent = () => {
  const cardsWrapperRef = useRef(null);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  let touchStartX = 0;
  let scrollLeftStart = 0;

  const cards = [
    { id: 1, text: 'Finding the\nbest-fit tender', number: '1', image: ImageCard.image1 },
    { id: 2, text: 'Preparation of\nBids - Support', number: '2', image: ImageCard.image2 },
    { id: 3, text: 'Contract Award\nSupport', number: '3', image: ImageCard.image3 },
    { id: 4, text: 'Post contract\nsupport', number: '4', image: ImageCard.image4 },
    { id: 5, text: 'Appeals and\nDispute Resolution', number: '5', image: ImageCard.image5 },
    { id: 6, text: 'Training', number: '6', image: ImageCard.image6 },
    { id: 7, text: 'Tender Alert\nService', number: '7', image: ImageCard.image7 },
  ];

  useEffect(() => {
    const wrapper = cardsWrapperRef.current;

    const handleWheel = (e) => {
      e.preventDefault();
      wrapper.scrollLeft += e.deltaY > 0 ? 400 : -400;
    };

    const handleTouchStart = (e) => {
      touchStartX = e.touches[0].clientX;
      scrollLeftStart = wrapper.scrollLeft;
    };

    const handleTouchMove = (e) => {
      e.preventDefault();
      const touchX = e.touches[0].clientX;
      const deltaX = touchX - touchStartX;
      wrapper.scrollLeft = scrollLeftStart - deltaX * 1.5;
    };

    wrapper.addEventListener('wheel', handleWheel);
    wrapper.addEventListener('touchstart', handleTouchStart);
    wrapper.addEventListener('touchmove', handleTouchMove);

    return () => {
      wrapper.removeEventListener('wheel', handleWheel);
      wrapper.removeEventListener('touchstart', handleTouchStart);
      wrapper.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);

  const handleMouseMove = (e, card) => {
    setCursorPos({ x: e.clientX, y: e.clientY });
    setHoveredCard(card);
  };

  const handleMouseLeave = () => {
    setHoveredCard(null);
  };

  return (
    <div className="container_card">
      <div className="card_container-text">
        <h1>SERVICES</h1>
        <p>Finding the best-fit tender. Bid Preparation. Contract Award Support. Post contract support</p>
      </div>
      <div className="cards-wrapper" ref={cardsWrapperRef}>
        {cards.map((card) => (
          <Link
            to="/services"
            key={card.id}
            className="card"
            onMouseMove={(e) => handleMouseMove(e, card)}
            onMouseLeave={handleMouseLeave}
          >
            <img src={card.image} alt={`Card ${card.id}`} />
            <div className="card-overlay" />
            <p className={`card-text ${hoveredCard?.id === card.id ? 'hovered' : ''}`}>
              {card.text}
              <img src={Icon.arrowIconB} alt="Arrow" />
            </p>
            <span className={`card-number ${hoveredCard?.id === card.id ? 'hidden' : ''}`}>
              {card.number}
            </span>
          </Link>
        ))}
      </div>
      <div
        className={`cursor-circle ${hoveredCard ? 'visible' : ''}`}
        style={{
          left: `${cursorPos.x - 3}px`,
          top: `${cursorPos.y - 3}px`,
        }}
      >
        VIEW
      </div>
    </div>
  );
};

export default CardsComponent;